import { heroStats } from "@/mocks/hotlist";
import LiveTicker from "@/pages/home/components/LiveTicker";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full min-h-[640px] md:min-h-[760px] flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20moody%20night%20cityscape%20with%20warm%20amber%20and%20crimson%20neon%20glow%2C%20dark%20charcoal%20atmosphere%2C%20glowing%20data%20streak%20lines%20and%20floating%20light%20particles%2C%20cinematic%20editorial%20background%2C%20high%20contrast%2C%20artistic%2C%20dramatic%20soft%20bokeh%20lights%2C%20modern%20entertainment%20portal%20aesthetic%2C%20no%20text&width=1600&height=900&seq=heiliaohome-hero-night&orientation=landscape"
          alt="夜间霓虹氛围的城市抽象背景，用于瓜田热榜首页首屏"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/75 to-background-50/95" />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/40 to-transparent" />

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 md:pt-32 pb-10">
        <div className="w-full max-w-6xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-primary-500/40 bg-primary-500/10 mb-6 animate-fade-up">
            <span className="w-2 h-2 rounded-full bg-primary-400 animate-pulse-dot" />
            <span className="text-xs md:text-sm text-primary-300 whitespace-nowrap">
              榜单实时更新中 · 今日已上榜 1,286 个话题
            </span>
          </div>

          <h1 className="font-heading font-bold text-foreground-950 text-4xl md:text-6xl lg:text-7xl leading-tight animate-fade-up">
            黑料首页
            <span className="block mt-3 text-2xl md:text-3xl lg:text-4xl text-primary-400">
              瓜田热榜 · 全网吃瓜热榜聚合
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 animate-fade-up">
            一屏看清当下最受关注的话题：热度榜看谁被最多人看到，热议榜看大家在争什么，爆款排行找正在快速传播的内容，围观涨粉榜看谁在悄悄起量。谁在涨粉、谁被群嘲，一目了然。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-fade-up">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-fire-fill" />
              立即看实时热榜
            </a>
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md border border-background-300/70 text-foreground-900 text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-background-200/60 transition-colors"
            >
              <i className="ri-bar-chart-grouped-line" />
              切换四大榜单
            </a>
          </div>

          <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 animate-fade-up">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200/70 bg-background-100/70 backdrop-blur-sm p-4 md:p-5"
              >
                <p className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tabular-nums">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500">{stat.unit}</span>
                </p>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600">{stat.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 animate-fade-up">
            <LiveTicker />
          </div>
        </div>
      </div>
    </section>
  );
}